import { ReactNode } from 'react'
import { RiArrowRightLine } from '@remixicon/react'
import styles from './home.module.css'

export function HomeHeading({
  id,
  title,
  children,
  center = false
}: {
  id: string
  title: ReactNode
  children?: ReactNode
  center?: boolean
}) {
  return (
    <div className={`${styles.heading} ${center ? styles.center : ''}`}>
      <h2 id={id} className={styles.title}>
        {title}
      </h2>
      {children && <p className={styles.description}>{children}</p>}
    </div>
  )
}

export function HomeLink({
  href,
  children,
  button = false
}: {
  href: string
  children: ReactNode
  button?: boolean
}) {
  return (
    <a className={button ? styles.button : styles.link} href={href}>
      {children}
      <RiArrowRightLine aria-hidden="true" />
    </a>
  )
}
